import { createSlice } from "@reduxjs/toolkit";
import { RootGlobalState } from "../stores/global";

export interface ConversationState {
  hardware: {
    cam?: string;
    mic?: string;
  };
  conversation: {
    userId?: string;
    eventId?: string;
    conversationId?: string;
  };
  available: boolean;
}
const initialState: ConversationState = {
  hardware: {},
  conversation: {
    userId: localStorage.getItem("user-id") ?? undefined,
    eventId: localStorage.getItem("event-id") ?? undefined,
  },
  available: true,
};

export const GlobalSlice = createSlice({
  name: "ConversationState",
  initialState,
  reducers: {
    setConversation(state: ConversationState, action: { payload: string }) {
      state.conversation.conversationId = action.payload;
    },
    setCameraId(state: ConversationState, action: { payload: string }) {
      state.hardware.cam = action.payload;
    },
    setMicrophoneId(state: ConversationState, action: { payload: string }) {
      state.hardware.mic = action.payload;
    },
    setUserId(state: ConversationState, action: { payload: string }) {
      state.conversation.userId = action.payload;
      localStorage.setItem("user-id", action.payload);
    },
    clearUserId(state: ConversationState) {
      state.conversation.userId = undefined;
      localStorage.removeItem("user-id");
    },
    setEventId(state: ConversationState, action: { payload: string }) {
      state.conversation.eventId = action.payload;
      localStorage.setItem("event-id", action.payload);
    },
    clearEventId(state: ConversationState) {
      state.conversation.eventId = undefined;
      localStorage.removeItem("event-id");
    },
    setAvailable(state: ConversationState, action: { payload: boolean }) {
      state.available = action.payload;
    },
  },
});
export const {
  setCameraId,
  setAvailable,
  setMicrophoneId,
  setConversation,
  setUserId,
  clearUserId,
  setEventId,
  clearEventId,
} = GlobalSlice.actions;
export const selectConversationUser = (state: RootGlobalState) =>
  state.conversation.conversation.userId;
export const selectConvInfo = (state: RootGlobalState) => state.conversation;
export const selectConvDevices = (state: RootGlobalState) =>
  state.conversation.hardware;
export const selectConversationConvID = (state: RootGlobalState) =>
  state.conversation.conversation.conversationId;
export const selectAvailableCore = (state: RootGlobalState) =>
  state.conversation.available;

// export const selectQuestionnaireValidStatus = (state: RootGlobalState) =>
//   state.questionnaire.valid;
export default GlobalSlice.reducer;
